import { render, staticRenderFns } from "./SmallCategory.vue?vue&type=template&id=c7961a70&scoped=true&"
import script from "./SmallCategory.vue?vue&type=script&lang=js&"
export * from "./SmallCategory.vue?vue&type=script&lang=js&"
import style0 from "./SmallCategory.vue?vue&type=style&index=0&id=c7961a70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7961a70",
  null
  
)

export default component.exports